import {EUR, USD} from '~/entities/currencies';

export const FIAT_DECIMALS = 2;

export const CURRENCIES = [
    {
        name: 'Euro',
        currency: EUR,
        decimals: FIAT_DECIMALS,
        decimals_assets: FIAT_DECIMALS,
        icon: 'https://s.raison-qa.dev/tokens/EUR/public/app_logo.svg',
    },
    {
        name: 'Dollar',
        currency: USD,
        decimals: FIAT_DECIMALS,
        decimals_assets: FIAT_DECIMALS,
        icon: 'https://s.raison-qa.dev/tokens/USD/public/app_logo.svg',
    },
];
